import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../utils/auth";
import { knockClient } from "../utils/knockClient";

export const KNOCK_AUTH_QUERY_KEY = ["knock-auth"];

export function useKnockAuth() {
    const { id: userId } = useAuth();

    return useQuery({
        queryKey: KNOCK_AUTH_QUERY_KEY,
        queryFn: async () => {
            await knockClient.authenticate(userId);
            return true;
        },
        enabled: !!userId,
        // Prevent unnecessary refetches since auth state rarely changes
        staleTime: Number.POSITIVE_INFINITY,
        // Keep the auth state even when window is unfocused
        refetchOnWindowFocus: false,
    });
}
